import { Descriptions, DescriptionsProps, Typography } from "antd";
import TypeViagem from "../../../../Models/Domain/Viagem/Viagem";
import { useViagemFechamentoObter } from "../../../../Services/Domain/Viagem/ViagemFechadaService";
import Utilitario from "../../../../Utils/Utilitario";
import TelaCarregamento from "../../../Base/Carregamento/TelaCarregamento";
const { Text } = Typography;

interface IViagemFechamentoInfoProps extends DescriptionsProps {
    viagem:TypeViagem;
}
export default function ViagemFechamentoInfo({
    viagem,
    title,
    bordered,
    ...rest
}:IViagemFechamentoInfoProps) {
    const {
        data,
        isPending,
        isLoading
    } = useViagemFechamentoObter({
        codViagem : viagem.codigo!
    });

    return <TelaCarregamento ativo={isPending || isLoading}>
        <Descriptions 
            {...rest}
            bordered={bordered === undefined ? true : (bordered ?? undefined)}
            title={title === undefined ? "Fechamento" : (title ?? undefined)}
            items={[
                {
                    key : 1,
                    label : "Receita",
                    children : <Text type={"success"}>{Utilitario.toStringDinheiro(data?.receita ?? 0)}</Text> 
                },
                {
                    key : 2,
                    label : "Despesas",
                    children : <Text type={"danger"}>{Utilitario.toStringDinheiro((data?.despesas ?? 0) * -1)}</Text>
                },
                {
                    key : 3,
                    label : "Lucro bruto",
                    children : <Text type={(data?.lucroBruto ?? 0) >= 0 ? "success" : "danger"}>{Utilitario.toStringDinheiro(data?.lucroBruto ?? 0)}</Text>
                }
            ]} 
        />
    </TelaCarregamento>;
}